export default __webpack_public_path__ + "static/media/sustainable.3ed25dd7.svg";